import type { ExcursionPage } from "../slug-excursions";
import gourdon from "@/assets/images/excursions/destinations/cannes.webp";

const page: ExcursionPage = {
  slug: "cannes-gourdon",
  hero: {
    title: "Excursion Cannes – Gourdon",
    subtitle:
      "Des plages de Cannes au village perché de Gourdon, un contraste spectaculaire.",
    ctaPrimaryHref: "/reservation",
    ctaPrimaryLabel: "Réserver",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "Devis",
    image: gourdon,
  },
  highlights: {
    title: "Points forts",
    items: [
      { text: "Cannes : Croisette, Suquet, plages privées (vue)" },
      { text: "Gourdon : village perché, panorama exceptionnel" },
      { text: "Artisans, confiseries, parfums et produits du terroir" },
      { text: "Route scénique par l’arrière‑pays azuréen" },
    ],
  },
  itinerary: {
    title: "Itinéraire type",
    steps: [
      { title: "Cannes", description: "Départ et tour rapide selon souhaits." },
      {
        title: "Route vers l'arrière‑pays",
        description: "Points de vue et arrêts photos.",
      },
      { title: "Gourdon", description: "Découverte du village, temps libre." },
    ],
  },
  practical: {
    title: "Infos pratiques",
    items: [
      { label: "Durée", value: "4 à 6 heures" },
      { label: "Départ", value: "Cannes" },
      { label: "Conseil", value: "Chaussures confortables (ruelles pavées)" },
      { label: "Option", value: "Arrêt parfumerie / confiserie selon envie" },
    ],
  },
};

export default page;
